import axios from "axios";
import Vue from "vue";

export const API_URL =
  process.env.NODE_ENV === "development"
    ? "/api-quatro"
    : "https://pmt.hmc.co.il/wp-json/quatro/v1";

export const authHeader = () => `Bearer ${Vue.$cookies.get("hmc_token")}`;

export async function getUserDetails(license) {
  try {
    const { status, data } = await axios.get(
      `${API_URL}/profile?license=${license}`,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    if (status === 200 && data["status"] === "success") return data["data"];
  } catch (err) {
    throw err;
  }
}

export async function requestUpdateUserDetails(license, body) {
  try {
    const { status, data } = await axios.post(
      `${API_URL}/profile?license=${license}`,
      body,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    if (status === 200) return data;
  } catch (err) {
    throw err;
  }
}

export async function requestUpdateUserAvatar(license) {
  try {
    const { status, data } = await axios.post(
      `${API_URL}/profile/avatar?license=${license}`,
      {},
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    if (status === 200) return data;
  } catch (err) {
    throw err;
  }
}

export async function sendLicensePlateForm(formData) {
  try {
    const { data } = await axios.post(`${API_URL}/car-license`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

export async function sendPolicies(formData) {
  try {
    const { data } = await axios.post(`${API_URL}/policies`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

/**
 * @deprecated Use {@link sendCelloSignGeneric} instead. This function targets
 * per-form legacy endpoints (e.g. /exception-committee-iframe) that have been
 * superseded by the unified /cellosign-generic endpoint. All current
 * iframeConfigs entries route through the generic flow; this function remains
 * only as a fallback for entries without a `generic` block.
 */
export async function sendCelloSign(payload, url) {
  try {
    const { data } = await axios.post(`${API_URL}/${url}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

export async function getDoctorSentencesByLicense(doctorLicense) {
  try {
    const { data } = await axios.get(
      `${API_URL}/doc-summary?license=${doctorLicense}`,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    return data;
  } catch (err) {
    throw err;
  }
}

export async function updateDoctorSentencesByLicense(doctorLicense, payload) {
  try {
    const { data } = await axios.post(
      `${API_URL}/doc-summary?license=${doctorLicense}`,
      payload,
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    return data;
  } catch (err) {
    throw err;
  }
}

/**
 * @deprecated Use {@link sendCelloSignGeneric} instead. The legacy
 * /consent-cellosign endpoint has been replaced by the unified
 * /cellosign-generic endpoint. No longer referenced anywhere in the app.
 */
export async function sendConsentCelloSign(payload) {
  try {
    const { data } = await axios.post(`${API_URL}/consent-cellosign`, payload, {
      headers: {
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

/**
 * Generic CelloSign endpoint. Replaces per-form endpoints
 * (e.g. /consent-cellosign, /exception-committee-iframe).
 *
 * @param {Object}        payload
 * @param {string}        payload.url       - CelloSign API URL to call (e.g.
 *                                            https://app.cellosign.com/api/v3/ivf_forms/seal/).
 * @param {string}       [payload.template] - CelloSign template UUID.
 * @param {Object|string} payload.data      - Form data passed through as-is.
 * @param {string}       [payload.project]  - CelloSign project. Defaults to
 *                                            doc_app_forms on the backend if omitted.
 * @param {string}       [payload.token]    - Override token. The backend uses a
 *                                            hard-coded token by default; only
 *                                            send this when a different one is required.
 * @param {boolean}     [payload.wait_for_first_session] - Whether to wait for
 *                                            the first signing session. Defaults
 *                                            to true on the CelloSign side if omitted.
 */
export async function sendCelloSignGeneric(payload) {
  try {
    const { data } = await axios.post(`${API_URL}/cellosign-generic`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: authHeader()
      }
    });
    return data;
  } catch (err) {
    throw err;
  }
}

export async function sendQueueCall(patientPhone, patientFullName) {
  try {
    const { data } = await axios.post(
      `${API_URL}/queue-call`,
      {
        phone: patientPhone,
        full_name: patientFullName
      },
      {
        headers: {
          Authorization: authHeader()
        }
      }
    );
    return data;
  } catch (err) {
    throw err;
  }
}
